import * as z from "zod";

export const getAMPGoogleFormURL = {
  name: "getAMPGoogleFormURL" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    url: z.string().nullable(),
    senderAddress: z
      .object({ localPart: z.string(), domain: z.string() })
      .nullable(),
  }),
};
